var scrollPos;

(function($){


  $(document).ready( function() {

    //$('img.grid-view-item__image').wrap('<span class="temp-image-wrap"></span>');
    
  });
  

  $('#easter-2023').each( function() {

    var preset = Cookies.get('easter-2023');
    if ( isNaN(parseInt(preset)) ) {
      var i = Math.round(Math.random() * 100);
    }
    else {
     $(this).find('.already-entered').css('display', 'block');
      var i = parseInt(preset);
    }
    var discount = i >= 95 ? 20 : 30;
    var code = i >= 95 ? 'ARI20' : 'ARI30';

    $(this).find('span.discount').text(discount);
    $(this).find('span.code').text(code);

    Cookies.set('easter-2023', i, { expires: 1, path: '/', domain: 'ariesarise.com' });

    
  });
  
  var header = $('#shopify-section-header');
  header.addClass('initialised');
  
  
  
  $('body').on('click', '.video-wrap-overlay', function() {
    
    var video = $(this).find('video').get(0);
    if ( video.paused ) {
      video.play(); 
      $(this).addClass('playing');
    }
    else {
      video.pause();
      $(this).removeClass('playing');
    }
  })
  
  var selectedCurrency = Cookies.get('selected-currency');
  
  
  if ( selectedCurrency == 'eur' && document.location.hostname.toLowerCase() != 'eu.ariesarise.com' ) {
    document.location.href = 'https://eu.ariesarise.com'+location.pathname;
  }
  else if ( selectedCurrency == 'jpy' && document.location.hostname.toLowerCase() != 'jp.ariesarise.com' ) {
    document.location.href = 'https://jp.ariesarise.com'+location.pathname;
  }
  else if ( selectedCurrency == 'usd' && document.location.hostname.toLowerCase() != 'us.ariesarise.com' ) {
  //else if ( selectedCurrency == 'usd' && document.location.hostname.toLowerCase() != 'www.ariesarise.com' ) {
    document.location.href = 'https://us.ariesarise.com'+location.pathname;
    //document.location.href = 'https://www.ariesarise.com'+location.pathname;
    
  }
  else if ( selectedCurrency == 'gbp' && document.location.hostname.toLowerCase() != 'www.ariesarise.com' && document.location.hostname.toLowerCase() != 'jp.ariesarise.com' ) {
    document.location.href = 'https://www.ariesarise.com'+location.pathname;
  }


    
  var geolocation = Cookies.get('geolocation');
  
  //geolocation.country = 'CA';

  
  if ( typeof geolocation !== 'undefined' ) {
    
    var geolocation = JSON.parse(Cookies.get('geolocation'));
    
    if ( geolocation.country == 'JP' && selectedCurrency == 'gbp' ) {
      Cookies.remove('dismiss-geolocation', {path: '/', expires: 365, domain: 'ariesarise.com'});
    }
    
  }
  
  if ( typeof geolocation == 'undefined' || geolocation == null ) {

     var geocode = Cookies.get('localization');
    
    if ( typeof geocode != 'undefined' ) {
        Cookies.set('geolocation', '{"country":"' + geocode + '"}', { expires: 1, path: '/', domain: 'ariesarise.com' });
    }
    else {
        Cookies.set('geolocation', 'false', { expires: 1, path: '/', domain: 'ariesarise.com' });
    }

    /*
    $.ajax({
      url: 'https://sisyphus.ariesarise.com/geolocation',
      dataType: 'jsonp',
      crossDomain: true,
      success: function (data) {
        if ( typeof data == 'object' && data.hasOwnProperty('ip') ) {
          Cookies.set('geolocation', JSON.stringify(data), { expires: 1, path: '/', domain: 'ariesarise.com' });
        }
        

        initGeolocationPopup(false);
      },
      error: function() {
        Cookies.set('geolocation', 'false', { expires: 1, path: '/', domain: 'ariesarise.com' });
        initGeolocationPopup(false);
      }
    });
    */
    
  }
  else {
    initGeolocationPopup(false); 
  }

  
  function initGeolocationPopup( forceDisplay ) {


    
    if ( document.location.href.indexOf('pages/tommy-party') >= 0 || document.location.href.indexOf('pages/easter') >= 0 ) {
      return false;
    }


    var geolocation = JSON.parse(Cookies.get('geolocation'));
    //geolocation.country = 'CA';
    
    var selectedCountry = Cookies.get('selected-shipping-country');
    
    $('.promo-banner').each( function() {
      
      var slideDown = false;
      
      //if ( Shopify.currency.active == 'GBP' && ['GB'].includes(geolocation.country) )
      if ( Shopify.currency.active == 'GBP')
        slideDown = true;
      else if ( Shopify.currency.active == 'USD' )
        slideDown = true;
      else if ( Shopify.currency.active == 'JPY' )
        slideDown = true;
      else if ( Shopify.currency.active == 'EUR' )
        slideDown = true;


      
      if ( Shopify.currency.active == 'GBP' && ['EU'].includes(geolocation.region) ) {
         $(this).find('.content-eu').show();
         $(this).find('.content-default').hide();
      }
      else if ( Shopify.currency.active == 'GBP' && ['JP'].includes(geolocation.country) ) {
         $(this).find('.content-jp').show();
         $(this).find('.content-default').hide();
      }


      
      $(this).find('.country').text(geolocation.country_name);


      
      if ( slideDown ) {   

        
        var data = $(this).data('settings').replace(/=>/igm, ':');        
            data = JSON.parse(data);
      
        
        //alert(selectedCountry);
        
        if ( selectedCountry == 'US' && data._shopify_shipping_promo_banner_usd_us == 'true' ) {
          
          if ( data._shopify_shipping_promo_banner_link_usd_us !== '' ) {
            $(this).find('.content-default').html('<a href="' + data._shopify_shipping_promo_banner_link_usd_us + '">' + data._shopify_shipping_promo_banner_text_usd_us + '</a>');
          }
          else {
            $(this).find('.content-default').html(data._shopify_shipping_promo_banner_text_usd_us);            
          }
          
        }
        else if ( selectedCountry == 'CA' && data._shopify_shipping_promo_banner_usd_ca == 'true' ) {
          
          if ( data._shopify_shipping_promo_banner_link_usd_ca !== '' ) {
            $(this).find('.content-default').html('<a href="' + data._shopify_shipping_promo_banner_link_usd_ca + '">' + data._shopify_shipping_promo_banner_text_usd_ca + '</a>');
          }
          else {
            $(this).find('.content-default').html(data._shopify_shipping_promo_banner_text_usd_ca);            
          }
          
        }
        else if ( selectedCountry == 'KR' && data._shopify_shipping_promo_banner_usd_kr == 'true' ) {
          
          if ( data._shopify_shipping_promo_banner_link_usd_kr !== '' ) {
            $(this).find('.content-default').html('<a href="' + data._shopify_shipping_promo_banner_link_usd_kr + '">' + data._shopify_shipping_promo_banner_text_usd_kr + '</a>');
          }
          else {
            $(this).find('.content-default').html(data._shopify_shipping_promo_banner_text_usd_kr);            
          }
          
        } 
        else if ( selectedCountry == 'AU' && data._shopify_shipping_promo_banner_usd_au == 'true' ) {

          if ( data._shopify_shipping_promo_banner_link_usd_au !== '' ) {
            $(this).find('.content-default').html('<a href="' + data._shopify_shipping_promo_banner_link_usd_au + '">' + data._shopify_shipping_promo_banner_text_usd_au + '</a>');
          }
          else {
            $(this).find('.content-default').html(data._shopify_shipping_promo_banner_text_usd_au);            
          }          
          
        } 
        else if ( selectedCountry == 'NZ' && data._shopify_shipping_promo_banner_usd_nz == 'true' ) {
         
          if ( data._shopify_shipping_promo_banner_link_usd_nz !== '' ) {
            $(this).find('.content-default').html('<a href="' + data._shopify_shipping_promo_banner_link_usd_nz + '">' + data._shopify_shipping_promo_banner_text_usd_nz + '</a>');
          }
          else {
            $(this).find('.content-default').html(data._shopify_shipping_promo_banner_text_usd_nz);            
          }          
          
        }         
        
        $(this).slideDown(500, function() {
          $('body, .site-header .header-primary-nav nav').css('padding-top', $(this).height() + 'px');
          //$('body, .site-header .header-primary-nav nav li ul').css('margin-top', $(this).height() + 'px');
          $('.cart-popup-wrapper').css('margin-top', $(this).height() + 'px');        
        }); 
        
      }
    });
    
    

    
    var dismissGeolocation = Cookies.get('dismiss-geolocation');
    
    
    if ( forceDisplay || ( typeof Cookies.get('selected-shipping-country') == 'undefined') || (typeof geolocation != 'undefined' && geolocation != 'false' && dismissGeolocation != 'true') ) {
      
      $('#shipping-popup .country').text(geolocation.country_name);
      
      
      /*
      if( Shopify.currency.active == 'GBP' && ['US','CA'].includes(geolocation.country) ) {
        $('body').addClass('.with-popup');  
        $('#shipping-popup .redirect-to-usd').show();
        $('#shipping-popup').fadeIn();
      }
      else if( Shopify.currency.active == 'GBP' && ['EU'].includes(geolocation.region) ) {
        $('body').addClass('.with-popup');  
        $('#shipping-popup .eu-shipping').show();
        $('#shipping-popup').fadeIn();
      }
      else if( Shopify.currency.active == 'USD' && ['GB','EU'].includes(geolocation.region) ) {
        $('body').addClass('.with-popup');  
        $('#shipping-popup .redirect-to-gbp').show();
        $('#shipping-popup').fadeIn();
      }
      else if( Shopify.currency.active == 'GBP' && ['JP'].includes(geolocation.country) ) {
        $('body').addClass('.with-popup');  
        $('#shipping-popup .jp-shipping').show();
        $('#shipping-popup').fadeIn();
      }
      */
      

      
      
      $('#shipping-popup select').change( function() {

        var currencyInfo = $(this.options[this.selectedIndex]).data('currency-info');
        var country = $(this).val();
        
        $('#shipping-popup .button').hide();
        $('#shipping-popup .info').hide();
        $('#shipping-popup .heading').hide();
        $('#shipping-popup .subheading').hide();

        if ( $(this).val() == 'JP' ) {
          $('#shipping-popup .button-jpy').show();
          $('#shipping-popup .info-jpy').show();
          $('#shipping-popup .heading-jpy').show();
          $('#shipping-popup .subheading-jpy').show();
        }
        else if ( typeof currencyInfo.eur !== 'undefined' && currencyInfo.eur ) {
          $('#shipping-popup .button-eur').show();
          $('#shipping-popup .info-eur').show();
          $('#shipping-popup .heading-eur').show();
          $('#shipping-popup .subheading-eur').show();
        }
        else if ( typeof currencyInfo.usd !== 'undefined' && currencyInfo.usd ) {
      
          $('#shipping-popup .button-usd').show();
          if ( country == 'US' )
            $('#shipping-popup .info-usd-us').show();
          else if ( country == 'CA' )
            $('#shipping-popup .info-usd-ca').show();
          else if ( country == 'KR' )
            $('#shipping-popup .info-usd-kr').show();
          else if ( country == 'AU' )
            $('#shipping-popup .info-usd-au').show();
          else if ( country == 'NZ' )
            $('#shipping-popup .info-usd-nz').show();          
          else
            $('#shipping-popup .info-usd').show();
          $('#shipping-popup .heading-usd').show();
          $('#shipping-popup .subheading-eur').show();
        }
          /*
          else if ( typeof currencyInfo.usd !== 'undefined' && currencyInfo.usd ) {
                    $('#shipping-popup .button-gbp').show();
          $('#shipping-popup .info-gbp-usd').show();
          $('#shipping-popup .heading-gbp').show();
          $('#shipping-popup .subheading-eur').show();
          }
            */
        else {
          $('#shipping-popup .button-gbp').show();
          $('#shipping-popup .info-gbp').show();
          $('#shipping-popup .heading-gbp').show();
          $('#shipping-popup .subheading-eur').show();
        }
        
        
      });
      
      

      //alert(Cookies.get('selected-shipping-country'));
      
      
      if(  
           (
             forceDisplay
             ||
             typeof Cookies.get('selected-shipping-country') == 'undefined'
             ||
             //(Shopify.currency.active == 'GBP' && (['US','CA'].includes(geolocation.country) || ['EU'].includes(geolocation.region) || ['JP'].includes(geolocation.country)))
             (Shopify.currency.active == 'GBP' && geolocation.country != 'UK')
             ||
             (Shopify.currency.active == 'USD' && ['EU'].includes(geolocation.region) || ['JP'].includes(geolocation.country))
             ||
             (Shopify.currency.active == 'EUR' && !['EU'].includes(geolocation.region))
             //||
             //(Shopify.currency.active == 'GBP' && ['JP'].includes(geolocation.country))
             ||
             (Shopify.currency.active == 'JPY' && !['JP'].includes(geolocation.country))
           )
           && !$('body,html').hasClass('with-sale-barrier') && document.location.hash != '#sale-barrier' 
        ) 
      {
        
          if ( forceDisplay )
             $('#shipping-popup .close').show();
          else
             $('#shipping-popup .close').hide();

        
          
          $('body').addClass('.with-popup');  
          $('#shipping-popup .content').show();
          $('#shipping-popup').fadeIn();
        
          //if ( typeof Cookies.get('selected-shipping-country') != 'undefined' )
          //  $('#shipping-popup select').val( Cookies.get('selected-shipping-country') ).trigger('change');
          //else
            $('#shipping-popup select').val( geolocation.country ).trigger('change');
   
        
      }
   
      $('#shipping-popup .button-wrap a').click( function() {
        //alert($('#shipping-popup select').val());
        
        Cookies.set('dismiss-geolocation', 'true', {path: '/', expires: 365, domain: 'ariesarise.com'});         
        Cookies.set('selected-currency', $(this).data('currency'), {path: '/', expires: 365, domain: 'ariesarise.com'});
        Cookies.set('selected-shipping-country', $('#shipping-popup select').val(), {path: '/', expires: 365, domain: 'ariesarise.com'});

        Cookies.set('page-view-count', 0);

        
        //if ( document.location.hash != '' ) {
          var redirect = this.href.replace(/\/$/, '') + document.location.pathname.replace(/\/$/, '') + (window.location.search == '' ? '' : '?' + window.location.search);
        
          document.location.href = redirect;
          return false;        
        //}


        showSubscribePopupHandler();
        
      });
      
      
      
      $('#shipping-popup .dismiss').click( function() {
        $('body').removeClass('.with-popup');  
        $('#shipping-popup').fadeOut();
        Cookies.set('dismiss-geolocation', 'true', {path: '/', expires: 365, domain: 'ariesarise.com'});
      });
      
      $('#geolocation-popup .dismiss').click( function() {
        $('body').removeClass('.with-popup');  
        $('#geolocation-popup').fadeOut();
        Cookies.set('dismiss-geolocation', 'true', {path: '/', expires: 365, domain: 'ariesarise.com'});
      });
      
    }

    if ( !$('body').hasClass('.with-popup') ) {

    }
    
  }
  
  $('.site-header .grid .header-primary-nav .region-nav li a').click( function() {
    initGeolocationPopup(true);
    return false;
    //Cookies.set('selected-currency', $(this).data('currency'), {path: '/', expires: 365, domain: 'ariesarise.com'});
  });
  


  
  $('#cookie-popup .btn').click( function() {
    $('#cookie-popup').fadeOut();
    Cookies.set('accept-cookies', 'true', { path: '/', expires: 365, domain: 'ariesarise.com' });
    showSubscribePopupHandler();
  });
    
  if ( typeof Cookies.get('accept-cookies') == 'undefined' ) {
    $('#cookie-popup').fadeIn();
  }
  
  
  $('button[name=gift-card-popup-init]').click( function() {
    
    $('body').addClass('.with-popup');  
    $('#gift-card-popup').appendTo( $('body') ).fadeIn();
    $('#gift-card-popup .close').unbind('click').click( function() {
      $('body').removeClass('.with-popup'); 
      $('#gift-card-popup').fadeOut();
      $('#gift-card-popup').find('input[type=text], textarea').val('');
    });
    $('#gift-card-popup button').unbind('click').click( function() {
      
      if ( $('#gift-card-popup input[name="properties[email]"]').size() > 0 ) {
      
        var email = $('#gift-card-popup input[name="properties[email]"]');
      
        if ( !validateEmail(email.val()) ) {
          email.prev().slideDown();
          return false;
        }
        
      }
      
      $('body').removeClass('.with-popup');  
      $('button[data-add-to-cart]').trigger('click');
      $('#gift-card-popup').fadeOut();
    });
    $('#gift-card-popup .radio-wrap input[value=select-date]').unbind('change').change( function() {
      if ( this.checked ) {
        $('#gift-card-popup .scheduler').val('').show();
        flatpickr($('#gift-card-popup .scheduler').get(0), {'position':'bottom center', 'minDate':new Date().toISOString().slice(0,10), 'onReady': function(){ $('#gift-card-popup .scheduler').focus() }});
      }
    });
    $('#gift-card-popup .radio-wrap input[value=send-now]').unbind('change').change( function() {
      if ( this.checked ) {
        $('#gift-card-popup .scheduler').val('').hide();
      }
    });
    
  });
  
  $('#site-footer .signup .field-container input, #site-footer .signup .field-container button').focus( function() {
    $('#site-footer .signup .field-container .field-wrap').slideDown(); 
  });
  
  
  window.getPageCount = function() {
    
    var i = parseInt(Cookies.get('page-view-count'));
    
    if ( isNaN(i) ) {

      i = 0;
    }
    
    return i;
    
  }
  
   

  Cookies.set('page-view-count', window.getPageCount()+1);
   
  
  $('body').on('change', 'form[name=signup] select[name=cd_COUNTRY]', function() {
    
    $('form[name=signup] input[name="addressbookid"]').val( $(this).find('option:selected').data('addressbookid') );
    
    //if( $(this).val() == 'United States') {
    //  $('#signup input[data-list]').attr('disabled', true);
    //  $('#signup input[data-list=usd]').attr('disabled', false);
    //}
    //else {
    // $('#signup input[data-list]').attr('disabled', true);
    //  $('#signup input[data-list=gbp]').attr('disabled', false);
    //}
    
  });

  function showBagPromoPopup() {
    
      if ( window.getPageCount() > 2 && Cookies.get('bag-promo-popup') != '1' ) {

        var expires = 28;
        var popup = $('#bag-promo-popup');

        popup.fadeIn();

        popup.find('.close').click( function() {
        $('body').removeClass('.with-popup'); 
        popup.fadeOut(500, function(){ $(this).remove(); });
        Cookies.set('bag-promo-popup', '1', { path: '/', expires: expires, domain: 'ariesarise.com' });
        });

        popup.find('a.btn').click( function() {
          Cookies.set('bag-promo-popup', '1', { path: '/', expires: expires, domain: 'ariesarise.com' });
        });
    
        popup.click(function(e){
        if(e.target != this) { return; }
        $('body').removeClass('.with-popup'); 
        popup.fadeOut(500, function(){ $(this).remove(); });  
        Cookies.set('bag-promo-popup', '1', { path: '/', expires: expires, domain: 'ariesarise.com' });    
        });
        
      }
    
  
  }

  //showBagPromoPopup();
  
  function showSubscribePopup() {

    
      if ( document.location.href.indexOf('pages/easter') >= 0 ) {
        return false;
      }
    
      var fm = $('#signup').clone(true);
    
      //var popup = $('<div class="popup-subscribe" id="popup-subscribe"><div class="sleeve"><div class="close"></div><div class="popup-content"></div></div></div>');


      var popup = $('#popup-subscribe');
    
      var expires = document.location.href.indexOf('collections/aries-vans-gyow') > -1 ? 1/24 : 28;      

    
      if ( fm.hasClass('with-image') )
        popup.addClass('with-image');
      
      if ( fm.hasClass('with-video') )
        popup.addClass('with-video');
      
      popup.hide();
      //popup.find('.popup-content').append(fm);

      $('body').addClass('.with-popup');    
      $('body').append(popup);
    
      popup.find('.close').click( function() {
        $('body').removeClass('.with-popup'); 
        //popup.fadeOut(500, function(){ $(this).remove(); });
        popup.fadeOut(500);
        Cookies.set('subscribe-popup', '1', { path: '/', expires: expires, domain: 'ariesarise.com' });
      });
    
      popup.click(function(e){
        if(e.target != this) { return; }
        $('body').removeClass('.with-popup'); 
        //popup.fadeOut(500, function(){ $(this).remove(); }); 
        popup.fadeOut(500);
        Cookies.set('subscribe-popup', '1', { path: '/', expires: expires, domain: 'ariesarise.com' });    
      });
    
      popup.fadeIn();

    popup.fadeIn();
    
  }

  function showSubscribePopupHandler() {


    //if ( $('#site-footer .signup.popup').length > 0 && Cookies.get('subscribe-popup') != '1' && ((Cookies.get('accept-cookies') == 'true' && window.getPageCount() > 2 ) || document.location.href.indexOf('collections/aries-vans-gyow') > -1) ) {
    //  if ( $('#site-footer .signup.popup').length > 0 && Cookies.get('subscribe-popup') != '1' && ((Cookies.get('accept-cookies') == 'true' && window.getPageCount() > 2 ) ) ) {

    if ( $('#site-footer .signup.popup').length > 0 && Cookies.get('subscribe-popup') != '1' && (Cookies.get('accept-cookies') == 'true' ) ) {
  
      var timeout = document.location.href.indexOf('collections/aries-vans-gyow') > -1 ? 1000 : 3000;
      timeout = 1000;
      setTimeout( function() {
        showSubscribePopup();
      }, timeout);  
    }
  
  }

  showSubscribePopupHandler();
  
  
 

  
  
  window.load_all_products = function( func ) {

     
    clearInterval(window.loading_products);
    
    window.loading_products = setInterval( function() {
      
      $('#pagination-wrap:not(.processing) .next a').trigger('paginate');
            
      if ( $('#pagination-wrap .next a').size() == 0 ) {
        clearInterval(window.loading_products);
        
        if ( typeof $('ul.grid').data('items') == 'undefined' )
          $('ul.grid').data('items', $('ul.grid').children().clone(true));
        
        if ( typeof func !== 'undefined' ) {
          func();
        }
      }
      
    }, 100);
    

    
  }

  $(document).ready( function() {
    
    $('.grid__item').animate({'opacity':1}, 1000 );
    
    
    var hash = window.location.hash;
    if (hash) {
    
      var hash = hash.replace(/#/, '');
          
      if ( hash == 'discount-added' ) {
        $('#lucky-dip-popup').fadeIn();
        $('#lucky-dip-popup .close').click(function() { $('#lucky-dip-popup').fadeOut(); });
      }
      if ( hash == 'hide-search-bar' ) {
        $('form[action="/search"]').hide();
      }
      
    }


    
      if ( ($('body').data('sale-barrier') == true && document.location.href.indexOf('pages/subscribe') == -1 && typeof Cookies.get('sale-barrier') == 'undefined') || document.location.hash == '#sale-barrier' ) {


        $('body,html').addClass('with-sale-barrier');
        $('.sale-barrier').show();
        
        if ( document.location.hash == '#' + $('.sale-barrier').data('code') )
           $('.sale-barrier input').val($('.sale-barrier').data('code'));

        if ( $('.sale-barrier').data('datetime') != '' ) {
            
            var timer = setInterval( function() {
      
               var s = $('.sale-barrier').data('datetime'); //"2022-06-16T07:00:00+0000";
               var d = new Date(Date.parse(s));
               var n = new Date();
              
               if ( d - n < 0 ) {
                 
                 $('.sale-barrier input, .sale-barrier button').prop('disabled', false);
                 clearInterval(timer);
                 $('.sale-barrier .countdown').text('');
                 return;
               }
              
               //$('.sale-barrier input, .sale-barrier button').prop('disabled', true);
              
               var hours = Math.floor(Math.abs(d - n) / (60*60*1000));
               var mins = Math.floor((Math.abs(d - n) - (hours*60*60*1000)) / (60*1000));
               var secs = Math.floor((Math.abs(d - n) - (hours*60*60*1000) - (mins*60*1000)) / (1000));
    
            
                $('.sale-barrier .countdown').text( hours + 'hr ' + mins + 'min ' + secs + 'sec' );
               
            }, 1000);

        }
        
        
        $('.sale-barrier .subscribe-link a').click( function() {
          showSubscribePopup();
          return false;
        });
        
      }
    
  });  
  
  

  
  
  $('.sale-barrier button').click( function() {
        
    if ( $('.sale-barrier input').val().toUpperCase() == $('.sale-barrier').data('code') ) {
      $('body,html').removeClass('with-sale-barrier');
      $('.sale-barrier').hide();
      Cookies.set('sale-barrier', 'true', { expires: 1, path: '/', domain: 'ariesarise.com' });
      //document.location.href = '/collections/retrosuperfuture';
      if ( $('.sale-barrier').data('destination-url') != '' ) {
        document.location.href = $('.sale-barrier').data('destination-url');
      }
      else {
        document.location.href = document.location.href;
      }
    }
    else {
      $('.sale-barrier .error').slideDown();
    }
    
  });

  
  $(window).on('scroll resize', function() {

    var y = $(window).scrollTop();

      if ( y < scrollPos || y < header.outerHeight(true) ) {
        header.removeClass('fixed');
      }
      else {
        header.addClass('fixed');
      }
      scrollPos = y;
 
  });
  
  $(window).scroll(function() {
          
      if ( $('#pagination-wrap .next a').size() > 0 ) {	

        var y = $('#pagination-wrap').offset().top;
        var x = $(window).scrollTop() + $(window).height();

        if ( y < x && !$('#pagination-wrap').hasClass('processing') ) {          
          $('#pagination-wrap .next a').trigger('click');
        }

      }

  });
  
  




  window.get_query_filters = function() {
    
    var queryFilters = {};
    queryFilters.category = [];
    queryFilters.size = [];
    queryFilters.discount = [];
    queryFilters.colour = [];
    queryFilters.gender = [];
    
    var query = window.location.search.replace('?', '');
    
    query = query.split('&');
    
    for ( var q in query ) {
     
      var item = query[q].split('=');
      
      if ( item.length == 2 && typeof queryFilters[item[0]] != 'undefined' && ( item[0] == 'category' || item[0] == 'size' || item[0] == 'discount' || item[0] == 'colour'  || item[0] == 'gender' ) ) {
        var key = item[0];
        var values = item[1].split(',');
        for ( var v in values ) {
          if ( values[v].length > 0 )
            queryFilters[key].push(values[v]);
        }
      }
          
      
    }

    queryFilters.isFiltered = queryFilters.category.length > 0 || queryFilters.size.length > 0 || queryFilters.discount.length > 0 || queryFilters.colour.length > 0 || queryFilters.gender.length > 0;
    
    return queryFilters;
    
  }
  
  
  window.apply_filters = function( updatedType ) {
   
    var queryFilters = window.get_query_filters();
    
    $('ul.grid').children().remove();
    
    if ( typeof $('ul.grid').data('items') == 'undefined' ) {
      return;
    }
    
    $('ul.grid').append($('ul.grid').data('items').css('opacity', 1));

         
    var lookup = {};
    
    $('ul.grid .grid__item').each( function() {
 
      
      var productFilters = $(this).data('product-filters');
      var productAvailibility = $(this).data('product-availibility');
      
      var include = true;
      
      for ( var prop in productFilters ) {
         
        for ( var prop2 in productFilters[prop] ) {
          lookup[prop + '|' + prop2] = productFilters[prop][prop2];
        }
        
      }
      
    
      
      for( var filter in queryFilters ) {
       
        if ( queryFilters[filter].length > 0 ) {
          

          var intersect = queryFilters[filter].filter(x => Object.keys(productFilters[filter]).includes(x));
        
          if(intersect.length == 0) {
             include = false; 
          }
          
          //console.log(include);
          
          if ( filter == 'size' ) {
            
            for ( var a in productAvailibility) {
               if ( !productAvailibility[a] )
                 delete productAvailibility[a];
            }
            var availibility = Object.keys(productAvailibility);
            
            var intersect = queryFilters[filter].filter(x => availibility.includes(x));
            
            if(intersect.length == 0) {
              include = false; 
            }
            
          }
          
        }
        
      }
                                        
      if ( !include )
        $(this).remove(); 

      
    });




    
    $('.collection-filter-wrap .filter-group li').each( function() {

      
      var filter = $(this);
      var disable = true;
      
      if ( filter.hasClass('active') )
        disable = false;
      
      $('ul.grid .grid__item').each( function() {
        
        if ( typeof $(this).data('product-filters')[filter.data('type')][filter.data('key')] !== 'undefined' )
          disable = false;
        
      });
      
      if ( typeof updatedType == 'undefined' || updatedType !== $(this).data('type') ) {
         
        if ( disable ){
          filter.addClass('disabled');
        }
        else {
          filter.removeClass('disabled');
        }
        
      }
      

    });

    
    $('.filter-no-results').hide();
    var labels = [];
    for ( var prop in queryFilters ) {
      labels.push( lookup[prop + '|' + queryFilters[prop]] );
    }
      
    labels = labels.filter(function (el) {return el != null;});
    
    $('.collection-filter-wrap .selected-filters').text( labels.join(', ') );
    

    if ( queryFilters.isFiltered )
      $('.collection-filter-wrap .filter-button').show();
    else
      $('.collection-filter-wrap .filter-button').hide();
    
    
    
    
    if ( $('ul.grid .grid__item').size() == 0 )
      $('.filter-no-results').slideDown();
    

    
  }


    $('.archive-sale-filters .toggle').click( function() {

      $(this).next('.sleeve').slideToggle();
      if ( $(this).find('span').text() == '-' ) {
        $(this).find('span').text('+');
      }else {
         $(this).find('span').text('-');
      }
      
    });
  
    $('.archive-sale-filters .clear-filters').click( function() {

      $('.filter-no-results').hide();
      
      $('.archive-sale-filters li').removeClass('active');

      $('ul.grid').children().remove();
      $('ul.grid').append($('ul.grid').data('items').css('opacity', 1));

      $('.archive-sale-filters .clear-filters span').text('');

      $('.archive-sale-filters .clear-filters').hide();

      
    });
  
    $('.archive-sale-filters li').click( function() {

      
      if ( !$('.archive-sale-filters').hasClass('initialised')  ) {
        alert('not yet initialized');
        return false;
      }

      $('.filter-no-results').hide();
      
      $('ul.grid').children().remove();
    
      $('ul.grid').append($('ul.grid').data('items').css('opacity', 1));

      if ( $(this).parent().hasClass('filter-category') ){

        $(this).toggleClass('active').siblings().removeClass('active');
        
        //if ( $(this).data('category') == 'all' ) {
        //  $(this).toggleClass('active').siblings().removeClass('active');
        //}
        //else {
        //  $(this).toggleClass('active').siblings('[data-category=all]').removeClass('active');
        //}
      }
      else if ( $(this).parent().hasClass('filter-size') ) {
        $(this).toggleClass('active');
      }
      
      var category = $('.archive-sale-filters .filter-category li.active').data('category');
      var size = $('.archive-sale-filters .filter-size li.active').data('size');


      
      
      $('ul.grid .grid__item').each( function() {

          var remove = false;

          if ( typeof category != 'undefined' && category != 'all' && typeof $(this).data('product-filters').category[category] == 'undefined' ) {
            remove = true;
          }
        
          if ( typeof size != 'undefined' && ( typeof $(this).data('product-filters').size[size] == 'undefined' || $(this).data('product-availibility')[size] == false )  ) {
            remove = true;
          }
        
          if ( remove ) {
            $(this).remove();
          }
        
      });


      
      if ( $('ul.grid .grid__item').size() == 0 )
        $('.filter-no-results').slideDown();

      $('.archive-sale-filters .clear-filters span').text(' (' + $('.filter-list .active').size() + ')');

      if ( $('.archive-sale-filters li.active').size() > 0 ) {
        $('.archive-sale-filters .clear-filters').show();
      }
      else {
        $('.archive-sale-filters .clear-filters').hide();
      }
      
    });
  
  window.build_filters = function() {

    
    $('.collection-filter-wrap .sleeve .filter-group li').remove();
    
    var items = {};
    items.category = {};
    items.size = {};
    items.discount = {};
    items.colour = {};
    items.gender = {};

    
    
    var queryFilters = window.get_query_filters();

    if ( typeof $('ul.grid').data('items') !== 'undefined' ) {
    
    $('ul.grid').data('items').each( function() {
        
      $(this).css('opacity', 1);
    
      var filters = $(this).data('product-filters');
      var availibility = $(this).data('product-availibility');

      if ( typeof filters.category != 'undefined' ) {
        for ( var p in filters.category ) {
          items.category[p] = '<li class="' + (queryFilters.category.includes(p) ? 'active' : '') + '" data-type="category" data-key="' + p + '">' + filters.category[p] + '</li>';
        }
      }  
      for ( var p in filters.size ) {
        
        if ( typeof availibility[p] !== 'undefined' && availibility[p] )
        items.size[p] = '<li class="' + (queryFilters.size.includes(p) ? 'active' : '') + '" data-type="size" data-key="' + p + '">' + filters.size[p] + '</li>';
      }
      for ( var p in filters.discount ) {
        items.discount[p] = '<li class="' + (queryFilters.discount.includes(p) ? 'active' : '') + '" data-type="discount" data-key="' + p + '">' + filters.discount[p] + '</li>';
      }
      for ( var p in filters.colour ) {
        items.colour[p] = '<li class="' + (queryFilters.colour.includes(p) ? 'active' : '') + '" data-type="colour" data-key="' + p + '">' + filters.colour[p] + '</li>';
      }
      for ( var p in filters.gender ) {
        items.gender[p] = '<li class="' + (queryFilters.gender.includes(p) ? 'active' : '') + '" data-type="gender" data-key="' + p + '">' + filters.gender[p] + '</li>';
      }
    
    });

    }
      
    var options = Object.values(items.category); options.sort(function(a, b){ a = $(a).text().toLowerCase(); b = $(b).text().toLowerCase(); if ( a < b ){ return -1; } else if( a > b ) { return 1; } else { return 0; }  });
    $('.collection-filter-wrap .sleeve .filter-group-category ul').append( options.join('') );
    
    var options = items.size;
    var tmp = [];
    if ( typeof options['xxs'] !== 'undefined' ) {
      tmp.push(options['xxs']);
      delete options['xxs'];
    }
    if ( typeof options['xs'] !== 'undefined' ) {
      tmp.push(options['xs']);
      delete options['xs'];
    }
    if ( typeof options['s'] !== 'undefined' ) {
      tmp.push(options['s']);
      delete options['s'];
    }
    if ( typeof options['m'] !== 'undefined' ) {
      tmp.push(options['m']);
      delete options['m'];
    }
    if ( typeof options['l'] !== 'undefined' ) {
      tmp.push(options['l']);
      delete options['l'];
    }
    if ( typeof options['xl'] !== 'undefined' ) {
      tmp.push(options['xl']);
      delete options['xl'];
    }
    if ( typeof options['xxl'] !== 'undefined' ) {
      tmp.push(options['xxl']);
      delete options['xxl'];
    }
     
    options = Object.values(items.size); ;
    
    options.sort(function(a, b){ a = isNaN(parseInt($(a).text().toLowerCase())) ? $(a).text().toLowerCase() : parseInt($(a).text().toLowerCase()); b = isNaN(parseInt($(b).text().toLowerCase())) ? $(b).text().toLowerCase() : parseInt($(b).text().toLowerCase()); if ( a < b ){ return -1; } else if( a > b ) { return 1; } else { return 0; }  });

    for (var o in options)
      tmp.push(options[o]);
    
    
    $('.collection-filter-wrap .sleeve .filter-group-size ul').append( tmp.join('') );
    
    var options = Object.values(items.discount); options.sort(function(a, b){ a = $(a).text().toLowerCase(); b = $(b).text().toLowerCase(); if ( a < b ){ return -1; } else if( a > b ) { return 1; } else { return 0; }  });
    $('.collection-filter-wrap .sleeve .filter-group-discount ul').append( options.join('') );
    
    var options = Object.values(items.colour); options.sort(function(a, b){ a = $(a).text().toLowerCase(); b = $(b).text().toLowerCase(); if ( a == 'other' ){ return 1; } else if ( a < b ){ return -1; } else if( a > b ) { return 1; } else { return 0; }  });
    $('.collection-filter-wrap .sleeve .filter-group-colour ul').append( options.join('') );
    
    var options = Object.values(items.gender); options.sort(function(a, b){ a = $(a).text().toLowerCase(); b = $(b).text().toLowerCase(); if ( a < b ){ return -1; } else if( a > b ) { return 1; } else { return 0; }  });
    $('.collection-filter-wrap .sleeve .filter-group-gender ul').append( options.join('') );
    
    
    $('.collection-filter-wrap .sleeve .filter-group ul').each( function() {
       if ( $(this).children().size() == 0 )
         $(this).parent().hide();
       else
         $(this).parent().show();
    });
      
    
    $('.collection-filter-wrap .sleeve .filter-group li').click( function() {
    
      $(this).toggleClass('active');
    
      var filters = {};
      filters.category = {};
      filters.size = {};
      filters.discount = {};
      filters.colour = {};
      filters.gender = {};
    
      $('.collection-filter-wrap .sleeve .filter-group-category ul li.active').each( function() {
         filters.category[$(this).data('key')] = $(this).data('key');
      });
      $('.collection-filter-wrap .sleeve .filter-group-size ul li.active').each( function() {
         filters.size[$(this).data('key')] = $(this).data('key');
      });
      $('.collection-filter-wrap .sleeve .filter-group-discount ul li.active').each( function() {
         filters.discount[$(this).data('key')] = $(this).data('key');
      });
      $('.collection-filter-wrap .sleeve .filter-group-colour ul li.active').each( function() {
        filters.colour[$(this).data('key')] = $(this).data('key');
      });
      $('.collection-filter-wrap .sleeve .filter-group-gender ul li.active').each( function() {
        filters.gender[$(this).data('key')] = $(this).data('key');
      });
    
      var query = [];
      for ( var f in filters ) {
        query.push(f + '=' + Object.values(filters[f]).join(','));
      }
      
      query = query.join('&');
    
    
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + query;
      window.history.pushState({path:newurl},'',newurl);
    
     
      window.apply_filters( $(this).data('type') );
      
    
    });
    



    
    $('.collection-filter-wrap, .archive-sale-filters').addClass('initialised').removeClass('loading');

    var query = window.location.search.replace('?', '').split('&');

    for ( var q in query ) {
      var item = query[q].split('=');
      if ( item.length == 2 && item[0] == 'filter-size' ) {
        var size = item[1];        
        setTimeout(function(){ $('.filter-list.filter-size li[data-size="' + size + '"]').trigger('click'); }, 250); 
      }
    }
      
  }
    


  
  
  $('.collection-filter-wrap .filter-toggle-wrap .clear-filters').click( function() {
     
      $('.collection-filter-wrap').removeClass('popup-visible');
      $('.collection-filter-wrap .sleeve').slideUp();
      $('.collection-filter-wrap .filter-toggle').removeClass('active');

      $('.collection-filter-wrap .sleeve .filter-group li').removeClass('active').removeClass('disabled');
    
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.pushState({path:newurl},'',newurl);

      window.apply_filters();

  });
  
  
  $('.collection-filter-wrap .close').click( function() {
    $('.collection-filter-wrap .filter-toggle').trigger('click');
  });
  
  
  $('.collection-filter-wrap .apply').click( function() {
    $('.collection-filter-wrap .filter-toggle').trigger('click');
  });
  
  
  $('.collection-filter-wrap .filter-toggle').click( function() {
    
       
    if (  $('.collection-filter-wrap .filter-toggle').hasClass('active') ) {
      $('.collection-filter-wrap').removeClass('popup-visible');
      $('.collection-filter-wrap .filter-toggle').removeClass('active');
      $('.collection-filter-wrap .selected-filters').show();
    }
    else {
      
      hj('trigger', 'filters_open');

      
      $('.collection-filter-wrap').addClass('popup-visible');
      $('.collection-filter-wrap .filter-toggle').addClass('active');
      $('.collection-filter-wrap .selected-filters').hide();
    }
        
    
    if ( !$('.collection-filter-wrap').hasClass('initialised') )
      $('.collection-filter-wrap').addClass('loading');
    
    
  });
  
  
  
  $('.product-single .product-detail-wrap .product-detail-item').click( function() {
    
    $(this).siblings().find('.sleeve').slideUp();
    
    $(this).find('.sleeve').slideToggle();
    
  });




  $(document).ready( function() {
    
    this.init = function() {
      window.build_filters();
      window.apply_filters();
    }
    
    
    window.load_all_products( this.init ); 
    
    
    //var filters = window.get_query_filters();
    
    /*
    if ( filters.isFiltered ) {
      window.load_all_products( window.build_filters ); 
    }
    else {
       window.load_all_products(); 
    }
    */
    
    $('.grid__item').animate({'opacity':1}, 1000 );
    
   
    
  });






















  
  
  
  

  
  
  
  $('.share-links').mouseenter( function() {
      $(this).find('.label').hide().next().slideDown();
  }).mouseleave( function() {
      $(this).find('.label').slideDown().next().hide();
  });
  
  
  $('.size-guide-show').click( function() {
    
     hide_popup_cart();
     hide_popup_menu();
     hide_popup_search(); 
    
     var x = $(window).scrollTop();

    
     $('html').addClass('js-popup-open');
     $('#size-guide').fadeIn();
    
     $(window).scrollTop(x);
    
     return false;
  });
  
  $('.size-guide-hide').click( function() {
   
    
     $('html').removeClass('js-popup-open');
     $('#size-guide').fadeOut();
    
     return false;
  });
  
  
  
  $('.cart-popup-wrapper').on('click', '.cart-popup-item__remove a', function() {
    
    $('.cart-popup-item-wrapper').addClass('refreshing');
        
    
    $.get(this.href).then( function() {
      
      if ( typeof window.cartPopup == 'undefined' ) {
        window.cartPopup = new theme.Product();
        window.cartPopup._setupCartPopup();
      }
      
      window.cartPopup._updateCartPopupContent();
    });
    return false;
  });
  
  //$('.site-header .site-header__regions ul').click( function() {
  //  $(this).addClass('active');
  //}).mouseleave( function() {
  //   $(this).removeClass('active');
  //});
  
  
  $('.site-header .site-header__regions ul').click( function() {
    initGeolocationPopup(true);
  });
  
  $('.site-header__cart').click(function(e) {
      
      
    if ( $(window).width() >= 750 ) {
      
      if ( $('.cart-popup-wrapper--hidden').size() == 0 ) {
        
        window.cartPopup._hideCartPopup();
        
      }
      else {
         
        hide_popup_size_chart();
        hide_popup_menu();
        hide_popup_search();  
      
        window.cartPopup = new theme.Product();
        window.cartPopup._setupCartPopup();
        window.cartPopup._showCartPopup(); 
        
      }
        
    }
    
    return false;
    
  });
  
 
  $('.site-header__cart').click( function() {
    
    if ( $(window).width() < 600 ) {
    
      hide_popup_size_chart();
      hide_popup_menu();
      hide_popup_search(); 
      
      if ( typeof window.cartPopup == 'undefined' ) {
        window.cartPopup = new theme.Product();
        window.cartPopup._setupCartPopup();
      }
      
      if ( $('.cart-popup-wrapper').hasClass('cart-popup-wrapper--hidden') ) {
        window.cartPopup._showCartPopup(); 
      }
      else {
        window.cartPopup._hideCartPopup();
      }
      
      
      return false;
    }
    
  });



  
  
    $('#primary-nav > li > a').mouseenter( function() {
    
      $('#primary-nav a').removeClass('active');
      $(this).addClass('active');
      $(this).parent().siblings('li').find('ul').removeClass('active');
      $(this).next('ul').addClass('active');
      
      
    }).click( function() {

      if ( $(this).next('ul').size() > 0 )
        return false;
     
    });
  
  
    $('#primary-nav .back-link').click( function() {
       $(this).parents('ul').removeClass('active');
    });
  
    $('#primary-nav').mouseleave( function() {
       $('#primary-nav a').removeClass('active');
       $(this).find('ul').removeClass('active');
    });
  
 
  

   $('.js-mobile-nav-toggle').click(function() {
        
      if ( $(window).width() < 600 ) {
        
        hide_popup_size_chart();
        hide_popup_cart();
        hide_popup_search();  
        
        if ( $('.site-header .header-primary-nav nav').hasClass('active') ) {
          $('html').removeClass('js-popup-open');
          $('.site-header .header-primary-nav nav').removeClass('active');
        }
        else {
          $('html').addClass('js-popup-open');
          $('.site-header .header-primary-nav nav').addClass('active');
        }
        
      }
      
   });
    
   $('.js-mobile-nav-toggle').click(function(evt) {
        
      if ( $(window).width() >= 600 ) {

          hide_popup_size_chart();
          hide_popup_cart();
          hide_popup_search();  
        
          if ( $('.site-header .header-primary-nav nav').hasClass('active') ) {
            $('html').removeClass('js-popup-open');
            $('.site-header .header-primary-nav nav').removeClass('active');
          }
          else {
            $('html').addClass('js-popup-open');
            $('.site-header .header-primary-nav nav').addClass('active');
          }

      }
     
      //console.log(1);
     
      evt.stopPropagation();
      evt.stopImmediatePropagation();
     
      return false;

    });
  
    $('.site-header .header-primary-nav nav').mouseleave( function() {
      $('.site-header .header-primary-nav nav').removeClass('active');
      
      $('html').removeClass('js-popup-open');
    });
  
    

    $('body .main-content').click( function() {
      console.log(2);
      if ( $('html').hasClass('js-popup-open') ) {
        $('.site-header .header-primary-nav nav').removeClass('active');
        $('html').removeClass('js-popup-open');
        return false; 
      }
    });
  
  

    $('.single-option-selector').change( function() {
      if ( $(this).val() != '' ) {
        $('.additional-checkout-buttons').slideDown();
      }
    });

  
    $('body button.product-form__cart-submit').click( function() {
      
      var submit = true;
      
      
      $('.single-option-selector').each( function() {
        if ( $(this).val() == '' ) {
          submit = false;
        }
      });
      
      
      $('.single-property-selector').each( function() {
        if ( $(this).val() == '' ) {
          submit = false;
        }
      });
     
      
      if ( !submit ) {
        $('#select-a-size').slideDown();
        setTimeout(function(){$('#select-a-size').slideUp();}, 1000);
        return false;
      }
      else {
        $('#select-a-size').slideUp();
        return true; 
      }
    });
  
  
    $('select#SingleOptionSelector-1').change( function() {
      if ( $(this).val() != '' ) {
        $('#select-a-size').slideUp();
      }
    });
    
 
  
    //$('body').on('mouseenter', 'button.product-form__cart-submit[aria-disabled="true"]', function() {
    //    $('#select-a-size').slideDown();
    //});
 

    //$('body').on('mouseleave', 'button.product-form__cart-submit[aria-disabled="true"]', function() {
    //  $('#select-a-size').slideUp();
    //});
  
  
    //$('select#SingleOptionSelector-1').trigger('change');
  
 
  

  
    function hide_popup_menu() {
      //alert(1);
      $('html').removeClass('js-popup-open');
      $('.site-header .header-primary-nav nav').removeClass('active');
    }
  
    function hide_popup_cart() {
      if ( typeof window.cartPopup !== 'undefined' )
        window.cartPopup._hideCartPopup();
    }
    function hide_popup_search() {
       
    }
    function hide_popup_size_chart() {
      $('html').removeClass('js-popup-open');
      $('#size-guide').fadeOut();
    }
  
  
    $('body').on('click paginate', '#pagination a', function(evt) {

      
      var link = $(this);
      
      $('#pagination-wrap').addClass('processing');

      $.ajax({
        type: 'get',
        url: this.href,
        success: function( data ) {
         
          //if ( window.loading_products )
          //  $('ul.grid').data('items').append($(data).find('.grid--view-items li'));
          //else
          

          
          //data = data.replace(/^.*?<body[^>]*>(.*?)<\/body>.*?$/s,'$1');
          
          data = data.replace(/<script[^>]*>[\s\S]*?<\/script>/g,'$1');
          
          
          $('.grid--view-items').append( $(data).find('.grid--view-items li') );
            
                    
          
          
          //console.log($('ul.grid').data('items').size());
          
          $('#pagination-wrap').removeClass('processing')
          
          $('#pagination-wrap').html( $(data).find('.pagination-wrap').html() );
          
          $('.grid__item').animate({'opacity':1}, 1000);

        },
        error: function() {
          
        }
      });


      evt.stopPropagation();
      evt.stopImmediatePropagation();
     
      return false;

    });

    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }





  
})(jQuery);


